import { render } from "./Programmatic Accountability Policy.vue?vue&type=template&id=b451e83e&scoped=true"
const script = {}

import "./Programmatic Accountability Policy.vue?vue&type=style&index=0&id=b451e83e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b451e83e"]])

export default __exports__